import { TableCell } from "@mui/material";
import { withStyles } from "@mui/styles";

const StyledCell = withStyles(() => ({
  root: {
    maxWidth: 16,
    width: 16,
    minWidth: 16,
    textAlign: "center",
  },
  sizeSmall: {
    padding: "0px 10px 0px 5px",
  },
}))(TableCell);

export default StyledCell;
